import React, { useContext, useRef, useState } from "react";
// import "../../tak-arz/Details.scss";
import "./twittes.scss";

import Swal from "sweetalert2";
import comment from "../../../assets/images/Icon awesome-comment.png";
import like from "../../../assets/images/Icon awesome-thumbs-up.png";
import dislike from "../../../assets/images/Icon awesome-thumbs-up-1.png";
import bookmark from "../../../assets/images/Icon feather-bookmark.png";
import retweet from "../../../assets/images/Icon awesome-retweet.png";
import share from "../../../assets/images/Icon ionic-md-share.png";
import more from "../../../assets/images/Icon material-more-vert.png";
import twitteContext from "context/twitteContext";
import { twitteTime } from "./twitteTime";
import axios from "axios";
import AuthenticationContext from "Authentication/AuthenticationContext.ts";
const TakTwitte = ({ value, index }) => {
  const auth = useContext(AuthenticationContext);
  const { updater, twittes, setTwitte, setUpdater } = useContext(twitteContext);
  const myRef = useRef(null);
  const executeScroll = () => myRef.current.scrollIntoView();
  async function ClickHandlerLike() {
    let fd = new FormData();
    fd.append("muid", 3);
    fd.append("twit_id", value.main_twit[0].id);
    await axios
      .post("http://cryptozoom.tatdemo.ir/api2/add_like", fd)
      .then((res) =>
        res.data.status == -1
          ? Swal.fire({
              title: "خطا",
              text: "این توییت را قبلا لایک کرده اید",
              confirmButtonText: "باشه",
              icon: "warning",
            })
          : setUpdater(!updater)
      );
  }
  async function ClickHandlerDislike() {
    let fd = new FormData();
    fd.append("muid", 3);
    fd.append("twit_id", value.main_twit[0].id);
    await axios
      .post("http://cryptozoom.tatdemo.ir/api2/add_dislike", fd)
      .then((res) =>
        res.data.status == -1
          ? Swal.fire({
              title: "خطا",
              text: "این توییت را قبلا دیسلایک کرده اید",
              confirmButtonText: "باشه",
              icon: "warning",
            })
          : setUpdater(!updater)
      );
  }
  async function Alert() {
    const result = await Swal.fire({
      title: "از حذف این توییت مطمئنید؟",
      text: "قابلیت بازگردانی آن وجود ندارد.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "حذف",
      cancelButtonText: "لغو",
    });
    if (result.isConfirmed) {
      DeleteHandler();
    }
  }
  async function DeleteHandler() {
    let fd = new FormData();
    fd.append("twit_id", value.main_twit[0].id);
    await axios
      .post("http://cryptozoom.tatdemo.ir/api2/delete_twit", fd)
      .then((res) => {
        if (res.data.status == 1) {
          Swal.fire({
            title: "حذف",
            text: "توییت شما با موفقیت حذف شد",
            confirmButtonText: "باشه",
            icon: "success",
          });
          setUpdater(!updater);
        } else {
          Swal.fire({
            title: "خطا",
            text: "مشکلی در حذف توییت به وجود آمده است",
            confirmButtonText: "باشه",
            icon: "error",
          });
        }
      });
  }
  if (value === null || typeof value === "undefined") return <></>;
  const detailsCount = {
    comment_count: value.comments_count,
    dislike_count: value.dislikes[0],
    like_count: value.likes[0],
  };
  let x;
  if (value.main_twit[0].parent_twit_id != 0) {
    x = twittes.find(
      (val) => value.main_twit[0].parent_twit_id == val.main_twit[0].id
    );
    // console.log(
    //   `twitte id ${value.main_twit[0].id}  parentID:${value.main_twit[0].parent_twit_id}   parent:${x}`
    // );
  }
  function text(textTwitte) {
    let reg = /#[A-Za-z\u0600-\u06FF_]+/g;
    let text = textTwitte;
    let y = text.match(reg);
    let result = text;
    if (y != null)
      y.forEach((value) => {
        result = result.replace(value, `<a style="color:red">${value} </a>`);
      });
    return <div dangerouslySetInnerHTML={{ __html: result }}></div>;
  }
  async function apihandler(id) {
    let fd = new FormData();
    fd.append("twit_id", id);
    await axios
      .post("http://cryptozoom.tatdemo.ir/api2/get_twit", fd)
      .then((res) => setTwitte(res.data.twits[0]));
  }
  
  return (
    <div className="card twitte ModalComment col-12" key={index}>
      <div style={{ textAlign: "left" }}>
        {auth.userInfo.id == value.main_twit[0].id ? (
          <div class="btn-group dropend">
            <button
              type="button"
              class="btn dropdown-toggle the-btn"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img src={more} alt="more" />
            </button>
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" href="#" onClick={Alert}>
                  حذف
                </a>
              </li>
            </ul>
          </div>
        ) : (
          <div></div>
        )}
      </div>
      <div className="row" style={{ alignItems: "center" }}>
        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-3">
          <div
            className="radius image point"
            data-bs-toggle="modal"
            data-bs-target="#TwitteModal"
            onClick={(e) => {
              apihandler(value.main_twit[0].id);
            }}
          >
            <img
              src={value.maker_twit_info[0].profile_pic[0]}
              className="icon"
            />
          </div>
        </div>
        <div
          className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-3 point"
          data-bs-toggle="modal"
          data-bs-target="#TwitteModal"
          onClick={(e) => {
            apihandler(value.main_twit[0].id);
          }}
        >
          {value.maker_twit_info[0].user[0].fullname}
        </div>
        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-3 point">
          {value.maker_twit_info[0].user[0].username}@
        </div>
        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-3">
          {twitteTime(value.main_twit[0].mtm)}
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-12">
          {value.file[0].length == 0 ? (
            text(value.main_twit[0].description)
          ) : (
            <>
              {text(value.main_twit[0].description)}
              <img
                src={value.file[0][0].url}
                alt="imageTwitter"
                style={{ width: "100%" }}
              />
            </>
          )}
        </div>
      </div>
      {x ? (
        <div className="card twitte retwitte col-12" ref={myRef} key={index}>
          <div className="row" style={{ alignItems: "center" }}>
            <div className="col-12 col-sm-6 col-md-6 col-xl-3 ">
              <div
                className="radius image point"
                data-bs-toggle="modal"
                data-bs-target="#TwitteModal"
                onClick={(e) => {
                  apihandler(value.main_twit[0].id);
                  executeScroll();
                }}
              >
                <img
                  src={x.maker_twit_info[0].profile_pic[0]}
                  className="icon"
                />
              </div>
            </div>
            <div
              className="col-12 col-sm-6 col-md-6 col-xl-3 point"
              data-bs-toggle="modal"
              data-bs-target="#TwitteModal"
              onClick={(e) => {
                apihandler(value.main_twit[0].id);
                executeScroll();
              }}
            >
              {x.maker_twit_info[0].user[0].fullname}
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-xl-3 point">
              {x.maker_twit_info[0].user[0].username}@
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-xl-3">
              {twitteTime(x.main_twit[0].mtm)}
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-12 col-sm-9 col-md-12 col-lg-12 col-xl-9">
              {x.file[0].length == 0 ? (
                text(x.main_twit[0].description)
              ) : (
                <>
                  {text(x.main_twit[0].description)}
                  <img
                    src={x.file[0][0].url}
                    alt="imageTwitter"
                    style={{ width: "100%" }}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      <div className="row">
        <div className="col-12 col-sm-6 col-md-12 col-lg-12 col-xl-6">
          <div className="row">
            <div className="col-4 iconF" onClick={ClickHandlerDislike}>
              <img src={dislike} alt="dislike" />
              {`(${detailsCount.dislike_count})`}
            </div>
            <div className="col-4 iconF" onClick={ClickHandlerLike}>
              <img src={like} alt="like" />
              {`(${detailsCount.like_count})`}
            </div>
            <div className="col-4 iconF">
              <img src={comment} alt="comment" />
              {`(${detailsCount.comment_count})`}
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-md-12 col-lg-12 col-xl-6" dir="ltr">
          <div className="row">
            <div className="col-2 col-md-1 iconF iconLeft">
              <img src={bookmark} alt="bookmark" />
            </div>
            <div className="col-2 col-md-1 iconF iconLeft">
              <img src={share} alt="share" />
            </div>
            <div className="col-2 col-md-1 iconF iconLeft">
              <img src={retweet} alt="retweet" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TakTwitte;
